<template>
  <div class="storeList">
    <p class="title">
      3.选择门店，进入下单界面
    </p>
    <div class="store_select">
      <div class="search" v-if="sendType===2">
        <div class="search_store">
          <input class="text" v-model="searcStoreName" placeholder="输入门店名称">
          <i class="cross"></i>
        </div>
        <span class="p-lr12">或</span>
        <div class="detailsearch">
          <div class="searchBox">
            <input class="text detailadd" @focus="getSelfLastAddress" @blur="hideAddress" @keyup="getMapAddress"
                   v-model="selfTakeaddress" placeholder="输入附近大厦/小区/学校查找门店">
            <i class="cross"></i>
            <div class="list-containter" ref="detailSearchEle" :style="detailSearchStyle"
                 v-if="(selfLastAddressShow&&lastConsigneeAddress.length>0)||(addressShow&&addressList.length>0)">
              <ul>
                <li class="list-item" v-if="selfLastAddressShow&&lastConsigneeAddress.length>0"
                    v-for="(item,index) in lastConsigneeAddress" :key="index" @mousedown="getAddress(item)"
                    :title="item.name">
                  <Poptip trigger="hover" placement="right" class="am-block" transfer >
                    <div slot="title">
                      <div class="list-item-text">{{item.name}}</div>
                    </div>
                    <div class="list-item-content">
                      <span class="z-tip-his" v-if="item.isHistory">历史地址</span>
                      <span>{{item.name}}</span>
                    </div>
                  </Poptip>
                </li>
                <li class="list-item" v-if="addressShow&&addressList.length>0" v-for="(item,index) in addressList"
                    :key="index" @mousedown="checkSelfAddress(item)" :title="item.name">
                  <Poptip trigger="hover" placement="right" class="am-block" transfer >
                    <div slot="title">
                      <div class="list-item-text">{{item.district}}{{item.name}}</div>
                    </div>
                    <div slot="content" >
                      <div class="list-item-text"> {{item.address}}</div>
                    </div>
                    <div class="list-item-content">
                      <div class="list-item-title am-text-truncate">
                        <span>{{item.name}}</span>
                        <span class="list-item-text ">{{item.district}}</span>
                      </div>
                      <div class="am-text-truncate list-item-text" v-if="item.address">
                        {{item.address}}
                      </div>
                    </div>
                  </Poptip>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="stores">
        <cc-loading-box class="loading-box" :isLoading="loading"></cc-loading-box>
        <div class="content2_msg" v-if="storeList.length ===0">{{'没有相关店铺，请重新设置查找条件'}}</div>
        <div class="store_items am-g-collapse" v-if="storeList.length>0">
          <div class="store_item am-u-sm-12"
               :class="{'store_item_more':store.isRange!==undefined&&!store.isRange&&!store.ccAnnouncement}"
               v-show="storeList[index].storeName.includes(searcStoreName)" v-for="(store,index) in storeList"
               :key="index">
            <span class="tip1" v-if="index == 0&& (store.isRange==undefined) && sendType !== 2">推荐</span>
            <div class="am-u-sm-12">
              <div class="store_name am-u-sm-4">
                <span class="fw-bold store_name_text" :title="store.storeName">{{store.storeName}}</span>
              </div>
              <div class="am-u-sm-4 am-u-end am-fl">
                <!--出餐时间-->
                <div class="store_take_time" v-if="sendType===2">
                  <span>{{store.waitTime}}分钟可取餐</span>
                  <span class="fs-12">{{store.storeAddress}}</span>
                </div>
                <div class="store_appointment_time" v-if="sendType===1||sendType ===4">
                  <span v-if="store.distance<1000">
                    <span v-show="userPosition.longitude&&userAddress">{{store.distance}} M | </span>
                    <span>{{store.waitTime}}分钟</span>
                  </span>
                  <span v-else>
                    <span v-show="userPosition.longitude&&userAddress">{{store.distance/1000}} KM  | </span>
                    <span>{{store.waitTime}}分钟</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="am-u-sm-12 am-padding-vertical-xs">
              <!--营业-->
              <template v-if="store.isServiceTime">
                <template v-if="store.isBusy">
                  <div class="font_red">
                    <!-- 门店繁忙 -->
                    <span v-if="(business.businessType == 1||business.businessType == 4)&&business.busy"
                          class="inline m-r10" v-for="(business,index) in store.businessChannels" :key="index">
											{{business.channelName}}繁忙
										</span>
                  </div>
                </template>
                <template v-else>
                  <div class="am-flex">
                    <div class="font_blue ">正常营业</div>
                    <div class="am-flex-num-2  am-padding-horizontal-sm am-text-group-2" :title="store.businessTimes | strTime">
                      ({{store.businessTimes | strTime}})
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <div class="am-u-sm-4" v-if="!store.isServiceTime">
									<span class="store_name_time" :title="store.businessTimes | strTime">门店休息
                    <span class="am-text-truncate">({{store.businessTimes | strTime}})</span>
									</span>
								</div>
              </template>
            </div>
            <div class="announcement" v-if="store.ccAnnouncement">
              公告：{{store.ccAnnouncement}}
            </div>
            <span class="btns">
                <a class="light m-r10" v-if="sendType===2" @click="checkRange(store)">查看地址</a>
                <a class="light m-r10" v-else @click="checkRange(store)">查看范围</a>
                <a v-if="store.isRange==undefined" class="dark m-r10" @click="placeOrder(store)">立即下单</a>
                <a v-if="isTableWare" class="dark"  @click="chooseTableWare(store)">餐具回收</a>
              </span>
            <span v-if="store.isRange!==undefined&&!store.isRange" class="outrange">不在配送范围</span>
          </div>
        </div>
        <div class="store_items_page" v-if="storeList.length>0">
          <span>第{{pageNow}}页</span>
          <cc-button type="primary" @click.prevent="btnPre" :disabled="!isPre">上一页</cc-button>
          <cc-button type="primary" @click.prevent="btnNext" :disabled="!isNext">下一页</cc-button>
          <span>共{{pages}}页</span>
        </div>
      </div>
      <div class="map" id="map-container"
           v-show="mapShow" :style="{top: sendType == 1 || sendType == 4 ? '0' : '50px'}">
        <a class="dark outRangeOrderBtn" v-show="outRangeStoreItem" @click="placeOrder(outRangeStoreItem)">立即下单</a>
      </div>
    </div>
  </div>
</template>

<script>
  import {each, formatTime } from '@/utils/assist';
  import Modal from '@/components/Cc-Modal'
  import Button from '@/components/Cc-Button'
  import LoadingBox from '@/components/Cc-Loading';
  import {mapState} from 'vuex'
  import Poptip from '@/components/Poptip/index'
  const cityRangeData = {}; // 城市范围数据
  export default {
    data() {
      return {
        detailSearchStyle: {height: 'auto'},
        mapShow: false
        , map: null
        , marker: null
        , icon: null
        , marker2: null
        , circle: null
        , infoWindow: null
        , searcStoreName: ''
        // ,address: ''
        , outRangeStoreItem: null
        , selfLastAddressShow: false
        , addressShow: false
        , addressList: []
        , coordinates: [0, 0] //经纬度集合 自取用
        , longitude: 0 //经度
        , latitude: 0 //维度
        , pageSize: 20
        , isTencentMap: this.tencentMapKey?true:false//是否腾讯地图
      }
    },
    props: {
    },
    filters: {
      strTime (list, s = ',') {
        let str = '';
        if (Array.isArray(list)) {
          let times = list.map(item => {
            return `${item.beginTime}-${item.endTime}`;
          });
          str += times.join(s);
        }
        return str
      }
    },
    created() {
      if (this.isAmend) {
        this.setAmendOrderBaseInfo();
      }
    },
    methods: {
      chooseTableWare (store) {
        let _this = this;
        // 参数回收
        this.$Modal.confirm({
          title: '提示',
          content: '选择餐具回收，骑手将会直接到顾客地址取回餐具，并返回门店。',
          onOk() {
            _this.placeOrder({...store, isNeedTableware: true});
          }
        })
      },
      changeTimes(timeArr) { // 转换时间显示格式
        if (timeArr && timeArr.length > 0) {
          let times = '营业时间：';
          timeArr.map(x => {
            times += x.beginTime + '-' + x.endTime + '  '
          });
          return times
        }
      },
      btnPre() { //上一页
        if (!this.isPre || this.pageNow == 1) {
          return
        }
        this.$store.dispatch('booking/user/update', {pageNow: this.pageNow - 1})
        this.getFindStoresByConds()
      },
      btnNext() { // 下一页
        if (!this.isNext) {
          return
        }
        this.$store.dispatch('booking/user/update', {pageNow: this.pageNow + 1})
        this.getFindStoresByConds()
      },
      newMapTencan () {
      
        this.map = new qq.maps.Map(document.getElementById("map-container"),{
            zoom: 13,
            disableDefaultUI:true
        });
         this.marker = new qq.maps.Marker({
          map: this.map
        });
         this.marker2 = new qq.maps.Marker({
          // icon: this.icon
           map: this.map,
           src:require("@/static/images/userPosition.png")
        });
        this.marker2.setIcon(require("@/static/images/userPosition.png"))
        this.marker2.setVisible(false);
        
         this.infoWindow = new qq.maps.InfoWindow({
          // offset: new AMap.Pixel(0, -20)
          map:this.map
        });
         this.circle = new qq.maps.Circle({
          fillOpacity: 0.2
          , strokeWeight: 1
          , map: this.map
        });
         this.polygon = new qq.maps.Polygon({
          fillOpacity: 0.2
          , strokeWeight: 1
          , map: this.map
        });
        // this.DistrictSearch = new qq.maps.service.District({
        //   polygon: 2
        // })
     

      },
      newMap() {
        if(this.tencentMapKey){
          this.newMapTencan()
          return false;
        }
        this.map = new AMap.Map('map-container', {
          zoom: 13
        });
        this.marker = new AMap.Marker({
          map: this.map
        });
        this.icon = new AMap.Icon({
          image: require("@/static/images/userPosition.png")
          , size: new AMap.Size(16, 26)
        });
        this.marker2 = new AMap.Marker({
          icon: this.icon
          , map: this.map
        });
        this.marker2.hide();
        this.infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -20)
        });
        this.circle = new AMap.Circle({
          fillOpacity: 0.2
          , strokeWeight: 1
          , map: this.map
        });
        this.polygon = new AMap.Polygon({
          fillOpacity: 0.2
          , strokeWeight: 1
          , map: this.map
        });
        this.DistrictSearch = new AMap.DistrictSearch({
          extensions: 'all',
          level: 'city',
          showbiz: false,
          subdistrict: 0
        })
      },
      checkRange(storeItem) { //查看范围
        let that = this,
          marker = this.marker,
          polygon = this.polygon;
        this.mapShow = true;
        if (!this.map) {
          this.newMap()
        }
        // 清除覆盖范围
        if (polygon&&typeof polygon.hide ==='function') {
          if(this.tencentMapKey){
          this.polygon.setVisible(false)
          }else{
          this.polygon.hide()
          }
        };
        //查看范围，加载地图
        let centerMap;
        if(this.tencentMapKey){
          centerMap = new qq.maps.LatLng(storeItem.coordinate[1],storeItem.coordinate[0]);
          this.map.setCenter(centerMap);
          if (marker)marker.setPosition(centerMap);
        }else{
          this.map.setCenter([storeItem.coordinate[0], storeItem.coordinate[1]]);
          if (marker)marker.setPosition([storeItem.coordinate[0], storeItem.coordinate[1]]);

        }
        if (storeItem.isRange != undefined && !storeItem.isRange) {
           let center2 ;
          if(this.tencentMapKey){
            center2 = new qq.maps.LatLng(this.userPosition.latitude,this.userPosition.longitude);
          }
          this.marker2.setPosition(this.tencentMapKey?center2:[this.userPosition.longitude, this.userPosition.latitude]);
          if(this.tencentMapKey){
            this.marker2.setVisible(true)
          }else{
            this.marker2.show();
          }
          this.outRangeStoreItem = storeItem;
        } else {
          if(this.tencentMapKey){
            this.marker2.setVisible(false)
          }else{
            this.marker2.hide();
          }
          this.outRangeStoreItem = null;
        }
        if ([1, 4].includes(this.sendType)) {
          this.infoWindow.close();
          this.circle.setCenter(this.tencentMapKey?centerMap:[storeItem.coordinate[0], storeItem.coordinate[1]]);
           if(this.tencentMapKey){
            this.circle.setVisible(true)
          }else{
            this.circle.show();
          }
          //范围类型，1:不规则范围；2:圆半径；3:全城送
          if (storeItem && storeItem.deliveryRanges.length > 0 && storeItem.deliveryRanges[0].status === 1) {
            if (storeItem.deliveryRanges[0].rangeType === 1) {
              let rangeArray = [];
              // for(let i=0;i<storeItem.dispatch.dispatchRange.longitudes.length;i++){
              //   let lnglat = Utils.mapTrans.bd2gd(storeItem.dispatch.dispatchRange.longitudes[i],storeItem.dispatch.dispatchRange.latitudes[i])
              //   rangeArray.push(lnglat)
              // }
              rangeArray = storeItem.deliveryRanges[0].coordinate;
              if(this.tencentMapKey){
                let rangeArray_ = rangeArray.map(m=>{
                  return new qq.maps.LatLng(m[1],m[0])
                })
                this.polygon.setPath(rangeArray_);
                 this.circle.setVisible(false);
                this.polygon.setVisible(true);
              }else{
              this.polygon.setPath(rangeArray);
                this.circle.hide();
                this.polygon.show();
              }
            
            } else if (storeItem.deliveryRanges[0].rangeType === 2) {
              this.circle.setRadius(storeItem.deliveryRanges[0].radius);
              if(this.tencentMapKey){
                this.polygon.setVisible(false);
                this.circle.setVisible(true);
              }else{
                this.polygon.hide();
                this.circle.show();
              }
            
            } else if (storeItem.deliveryRanges[0].rangeType === 3) { // 全城送处理 获取节点
              let self = this, cityName = storeItem.cityName;
              if(cityRangeData[cityName]) {
                if(this.tencentMapKey){
                  this.polygon.setPath(cityRangeData[cityName]);
                  this.polygon.show();
                }else{
                  self.polygon.setPath(cityRangeData[cityName]);
                  self.polygon.show();
                }
             
              } else {
                if(this.tencentMapKey){

                }else{
                  this.DistrictSearch.search(cityName,function (status, {districtList}) { // 城市名称
                    if (status === 'complete') {
                      let cityData = districtList[0],
                        range = cityData.boundaries[0].map(function (item)  {
                          return [item.lng, item.lat];
                        });
                      self.polygon.setPath(cityRangeData[cityName] = range);
                      self.polygon.show();
                    }
                  });
                }
              }

              console.log("全城配送！");
              //this.polygon.hide();
              this.tencentMapKey?this.circle.setVisible(false):this.circle.hide();
            }
          }
        } else { // 自取地图显示
          this.infoWindow.setContent(storeItem.storeName);
          if(this.tencentMapKey){
            let positionCenter = this.marker.getPosition()
            let centerInfo = new qq.maps.LatLng(positionCenter.lat,positionCenter.lng);
            this.infoWindow.close();
            this.infoWindow.setContent(storeItem.storeName);
            this.infoWindow.setPosition(this.marker.getPosition());
            setTimeout(()=>{
            this.infoWindow.open();
            },300)


            if (this.selfTakeaddress) { //显示人的图标
              let center2 = new qq.maps.LatLng(that.coordinates[1],that.coordinates[0]);
              this.marker2.setPosition(center2);
              this.marker2.setVisible(true);
            } else {
              this.marker2.setVisible(false);
            }
            this.circle.setVisible(false);

          }else{
            this.infoWindow.open(this.map, this.marker.getPosition());
            if (this.selfTakeaddress) { //显示人的图标
              this.marker2.setPosition([that.coordinates[0], that.coordinates[1]]);
              this.marker2.show();
            } else {
              this.marker2.hide();
            }
            this.circle.hide();
          }
          
          this.outRangeStoreItem = null;
        }
      },
      actionLoading(boole) {
        this.$store.dispatch('booking/user/update', {
          storeListLoading: !!boole
        })
      },
      getFindStoresByConds() { //根据复合条件获取门店列表
        this.actionLoading(true);
        this.server
          .get({
            name: "getFindStoresByConds",
            data: {
              // content:{
              address: this.selfTakeaddress
              , brandName: this.brandInfo.brandName
              , storeName: ''
              , orderType: 2
              , provinceId: this.provinceId
              , cityId: this.cityId
              , districtId: this.districtId
              , brandIds: [this.brandInfo.brandId]
              , storeIds: []
              , coordinates: this.coordinates
              , pageSize: this.pageSize
              , pageNow: this.pageNow
              // }
              // ,platformKey: this.brandInfo.platformKey
            }
          })
          .then(result => {
            if (result.status === 1) {
              let o = {};
              if (result.data.rows.length > 0) {
                Object.assign(o, {
                  storeList: result.data.rows,
                  pageNow: result.data.page,
                  pages: result.data.pages,
                  total: result.data.total
                });
                // 判断分页
                if (result.data.page == 1) {
                  o.isPre = false;
                } else {
                  o.isPre = true;
                }

                if (result.data.total > (result.data.page * result.data.pageSize)) {
                  o.isNext = true;
                } else {
                  o.isNext = false;
                }
              } else {
                // 重置
                Object.assign(o, {
                  storeList: [],
                  pageNow: 1,
                  pages: 0,
                  total: 0,
                  isPre: false,
                  isNext: false
                });
              }
              this.$store.dispatch('booking/user/update', o)
            }
          }).finally(() => {
          this.actionLoading()
        })
      },
      placeOrder(item) {

        // CCFS 弹屏特殊处理
        // shopCode ordererName ordererPhone memberName contactorPhone gender province city district address construction otherPhone sign remarks chnnel longitude latitude
        let qcurl = `//stage.4009870870.com/ccfs/ccfsOrder.htm?kefuCode=hgds01&shopCode=${item.mappingCode}&ordererName=${this.name}&ordererPhone=${this.phone}&orderUserArea=${this.countryCode}&memberName=${this.name}&contactorPhone=${this.phone}&gender=${this.sex==1?'r':'s'}&province=${this.provinceName}&city=${this.cityName}&district=${this.districtName}&address=${this.consigneeAddress}&construction=${this.detailAddress}&channel=${1}&longitude=${this.ccfs_longitude}&latitude=${this.ccfs_latitude}`
        let url = `//www.4009870870.com/ccfs/ccfsOrder.htm?kefuCode=hgds01&shopCode=${item.mappingCode}&ordererName=${this.name}&ordererPhone=${this.phone}&orderUserArea=${this.countryCode}&memberName=${this.name}&contactorPhone=${this.phone}&gender=${this.sex==1?'r':'s'}&province=${this.provinceName}&city=${this.cityName}&district=${this.districtName}&address=${this.consigneeAddress}&construction=${this.detailAddress}&channel=${1}&longitude=${this.ccfs_longitude}&latitude=${this.ccfs_latitude}`
        if(!window.standardDB){ // QC环境
          if(this.brandInfo.platformKey == 'cfffb941289a08f9'&&(item.storeId === 649||item.storeId === 10994)){
            let _this = this, msg = '', state = true, required = true, validations = [
              {key: 'sex', msg: '性别为必选', reg:  /^0{1}$/g},
              {key: 'mappingCode', msg: '第三方门店编号不能为空', required},
              {key: 'name', msg: '收货人姓名不能为空', required},
              {key: 'phone', msg: '收货人电话不能为空', required},
              {key: 'provinceName', msg: '省份不能为空', required},
              {key: 'cityName', msg: '城市不能为空', required},
              {key: 'districtName', msg: '区域不能为空', required},
              {key: 'consigneeAddress', msg: '地址不能为空', required},
              {key: 'ccfs_longitude', msg: '经度不能为空', reg: /^0{1}$/g},
              {key: 'ccfs_latitude', msg: '维度不能为空', reg: /^0{1}$/g}
            ];
            validations.find((item) => {
              let { key, required, reg } = item,
                value = _this[key];
              if(_this.hasOwnProperty(key)&&((required&&value === '') || (typeof reg === 'object'&&Object.prototype.toString.call(reg) === '[object RegExp]'&&reg.test(value)))) {
                msg = item.msg;
                state = false;
              }
              return !state
            });
            if (!state) {
              return this.$Modal.error({
                title: '提示',
                msg
              })
            }
            window.open(qcurl, "_blank");
            return
          }
        }else{ // 正式环境
        }
        this.$emit('openOrderPage', item)
      },
      getSelfLastAddress() { //获取最后一次自取单地址与坐标
        this.addressShow = true;
        if (this.selfTakeaddress.length > 0) {
          this.selfLastAddressShow = false;
        } else {
          this.selfLastAddressShow = true;
        }
      },
      getAddress(item) {
        this.selfTakeaddress = item.name;
        this.longitude = item.longitude;
        this.latitude = item.latitude;
        this.coordinates = [this.longitude, this.latitude];
        this.hideAddress();
        this.getFindStoresByConds();
      },
      hideAddress() {
        this.selfLastAddressShow = false;
        this.addressShow = false;
      },
      wemapSearch(){
        let that = this
        if (that.selfTakeaddress == '' && that.sendType === 2) {
          that.selfTakeaddress = '';
          that.coordinates = [0, 0];
          that.getFindStoresByConds()
          return;
        }
        if (this.selfTakeaddress !== '') {
          this.selfLastAddressShow = false;
          // //查询地图地址
          // this.autocomplete = new AMap.Autocomplete({
          //   city: this.cityName,
          //   citylimit: true
          // })
          // this.autocomplete.search(that.selfTakeaddress, function (status, result) {
          //   console.log(status, result, 555)
          //   // 第三方地图有返回
          //   if (status == 'complete') {
          //     let tipsArr = []
          //     // 地图地址处理 需加上district+name
          //     if (result.tips && result.tips.length > 0) {
          //       result.tips.map(item => {
          //         let  { district = '', address, name } = item;
          //         if (item.location&&name) { //过滤坐标为空的地址
          //           name = name.replace(district, '');
          //           item.address = '' + address;
          //           tipsArr.push({...item, name, label: item.name});
          //         }
          //       })
          //     }
          //     that.addressList = tipsArr;
          //   } else if (status = 'no_data') {
          //     that.addressList = []
          //   }
          // })

          let data = {
            keyword:that.selfTakeaddress,
            key: this.tencentMapKey, //key为自己向腾讯地图申请的密钥
            region:this.cityName,
            output:'jsonp',
            region_fix:1
          };

          var url = "https://apis.map.qq.com/ws/place/v1/suggestion/";
          $.ajax({
            type: "get",
            dataType: 'jsonp',
            data: data,
            url: url,
            async:false,
            jsonp:'callback',
            success: function (result) {
                  let tipsArr = []
                // 地图地址处理 需加上district+name
                if (result.data && result.data.length > 0) {
                  result.data.map(item => {
                    let {district = '', address, title} = item;
                    if (item.location && title) { //过滤坐标为空的地址
                      let name = title.replace(district, '');
                      item.address = '' + address;
                      tipsArr.push({...item, name, label: item.name});
                    }
                  })
                }
                that.addressList = tipsArr;
              
            },
            error: function (err) {
                console.log(err,'smileer r');
                that.addressList = []
            }
          });


        } else { //地址为空则获取所有自取门店信息
          this.coordinates = [0, 0];
          this.getFindStoresByConds();
        }

      },
      getMapAddress() {
        // 腾讯地图
        if(this.tencentMapKey){
          if(this.wemapTime){
            clearTimeout(this.wemapTime)
          }
          this.wemapTime = setTimeout(()=>{
            this.wemapSearch();
          },400)
          return false;
        }
        let that = this
        if (that.selfTakeaddress == '' && that.sendType === 2) {
          that.selfTakeaddress = '';
          that.coordinates = [0, 0];
          that.getFindStoresByConds()
          return;
        }
        if (this.selfTakeaddress !== '') {
          this.selfLastAddressShow = false;
          //查询地图地址
          this.autocomplete = new AMap.Autocomplete({
            city: this.cityName,
            citylimit: true
          })
          this.autocomplete.search(that.selfTakeaddress, function (status, result) {
            console.log(status, result, 555)
            // 第三方地图有返回
            if (status == 'complete') {
              let tipsArr = []
              // 地图地址处理 需加上district+name
              if (result.tips && result.tips.length > 0) {
                result.tips.map(item => {
                  let  { district = '', address, name } = item;
                  if (item.location&&name) { //过滤坐标为空的地址
                    name = name.replace(district, '');
                    item.address = '' + address;
                    tipsArr.push({...item, name, label: item.name});
                  }
                })
              }
              that.addressList = tipsArr;
            } else if (status = 'no_data') {
              that.addressList = []
            }
          })
        } else { //地址为空则获取所有自取门店信息
          this.coordinates = [0, 0];
          this.getFindStoresByConds();
        }
      },
      checkSelfAddress(item) {
        this.selfTakeaddress = item.name;
        this.longitude = item.location.lng;
        this.latitude = item.location.lat;
        this.coordinates = [this.longitude, this.latitude];
        this.hideAddress();
        this.getFindStoresByConds();
      },
      setAmendOrderBaseInfo () {
        let storeUser = this.$store.state.booking,
          userData = storeUser.user;
        this.getAddress({
          selfTakeaddress: userData.address,
          longitude: userData.longitude,
          latitude: userData.latitude,
          coordinates: [userData.longitude, userData.latitude]
        })
      }
    },
    components: {
      ccLoadingBox: LoadingBox,
      Modal,
      ccButton: Button,
      Poptip
    },
    computed: {
      ...mapState({
        userAddress: state => state.booking.user.address, // 用户地址
        isTableWare: state => state.booking.user.oprInfo.tablewareRecycling,// 餐具回收
        loading: state => state.booking.user.storeListLoading,
        storeList: state => state.booking.user.storeList,
        sendType: state => state.booking.user.sendType,
        userPosition: state => {
          let user = state.booking.user;
          return {
            longitude: user.longitude,
            latitude: user.latitude
          }
        },
        brandInfo: state => state.booking.user.brandInfo,
        phone: state => state.booking.user.phone,
        countryCode: state => state.booking.user.countryCode,
        name: state => state.booking.user.name,
        provinceId: state => state.booking.user.provinceId,
        cityId: state => state.booking.user.cityId,
        districtId: state => state.booking.user.districtId,
        lastConsigneeAddress: state => state.booking.user.lastConsigneeAddress || [], // 自取单信息
        // 门店分页数据
        pageNow: state => state.booking.user.pageNow,
        total: state => state.booking.user.total,
        pages: state => state.booking.user.pages,
        isPre: state => state.booking.user.isPre,
        isNext: state => state.booking.user.isNext,
        cityName: state => state.booking.user.cityName,
        // ccfs对接
        provinceName: state => state.booking.user.provinceName,
        districtName: state => state.booking.user.districtName,
        consigneeAddress: state => state.booking.user.consigneeAddress,
        detailAddress: state => state.booking.user.detailAddress,
        ccfs_longitude: state => state.booking.user.longitude,
        ccfs_latitude: state => state.booking.user.latitude,
        sex: state => state.booking.user.sex,
        isAmend: state => state.booking.user.orderAmend.isAmend,
        tencentMapKey:state =>state.booking.user.tencentMapKey
      }), selfTakeaddress: {
        get() {
          return this.$store.state.booking.user.selfTakeaddress
        }
        , set(val) {
          this.$store.dispatch('booking/user/update', {selfTakeaddress: val})
        }
      }
    },
    watch: {
      storeList(val, oldVal) {
        setTimeout(() => {
          if (this.storeList && this.storeList.length > 0) {
            this.checkRange(this.storeList[0])
          } else if (this.storeList.length == 0) {
            this.mapShow = false;
          }
        })
      },
      addressList (list) {
        // 地址监听
        this.$nextTick(()=> {
          let ele = this.$refs.detailSearchEle, height = 0;
          if (list&&list.length>6){
            let childs = ele.querySelectorAll('li.list-item');
            childs.forEach((child, index) => {
              if (index<6) {
                height += child.offsetHeight;
              }
            });
            height += 'px'
          } else {
            height = 'auto'
          }
          this.detailSearchStyle = {height}
        })
      },
      isAmend (val) {
        if (val) {
          this.setAmendOrderBaseInfo();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .storeList {
    .store_select {
      position: relative;
      width: 800px;
    }
    .search {
      height: 42px;
      line-height: 42px;
      // padding-left: 20px;
      margin-bottom: 8px;
      .search_store {
        position: relative;
        display: inline-block;
        width: 250px;
        font-size: 14px;
        .detailadd {
          width: 250px;
        }
      }
      .search_store input.text {
        width: 100%;
      }
      .search_nearby {
        display: inline-block;
        position: relative;
        .detailadd {
          width: 250px;
        }
      }
    }
    .content2_msg {
      font-size: 16px;
      text-align: center;
      margin-top: 30px;
    }
    .stores {
      position: relative;
      height: 440px;
      overflow: hidden;
      background-color: #fff;
      // padding-left: 20px;
      .store_items_page {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 40px;
        line-height: 40px;
        text-align: center;
      }
      .store_items {
        position: absolute;
        height: 400px;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 6px;
          background-color: #dde0e3;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #3b5d8b;
        }
        .store_item_more {
          position: relative;
          height: auto;
          border-top: 1px solid #d2dadd;
          padding: 18px 0 28px 18px !important;
        }
        .store_item {
          position: relative;
          height: auto;
          border-top: 1px solid #d2dadd;
          padding: 18px 0 10px 18px;
          .store_name {
            display: inline-block;
           // width: 30%;
            .store_name_text {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            .store_name_time {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            span {
              height: 24px;
              line-height: 24px;
              display: block;
            }
            span.inline {
              display: inline-block;
            }
          }
          .store_take_time {
            display: inline-block;
            //width: 30%;
            span {
              display: block;
            }
          }
          .store_appointment_time {
            display: inline-block;
            //width: 30%;
            vertical-align: top;
            span {
              vertical-align: middle;
            }
          }
          .announcement {
            width: 630px;
          }
          .tip1 {
            position: absolute;
            width: 30px;
            height: 20px;
            top: -1px;
            left: 0;
            line-height: 20px;
            font-size: 12px;
            color: #fff;
            background-color: #f73f3f;
          }
          .tip1:after {
            content: '';
            position: absolute;
            top: 0;
            right: -10px;
            width: 0;
            height: 20px;
            border-right: 10px solid rgba(0, 0, 0, 0);
            border-top: 9px solid #f73f3f;
            border-bottom: 9px solid #f73f3f;
          }
          .btns {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 12px;
            z-index: 10;
          }
          .btns > a {
            padding: 0 18px;
          }
          .rows {
            position: relative;
            height: 22px;
            line-height: 22px;
          }
          .rows2 {
            position: relative;
            font-size: 12px;
            min-height: 20px;
            line-height: 20px;
            .col2 {
              display: inline-block;
              width: 50%;
            }
          }
        }
        .store_item:last-child {
          border-bottom: 1px solid #d2dadd;
        }
      }
    }
    .map {
      position: absolute;
      top: 50px;
      left: 810px;
      width: 418px;
      height: 334px;
      background-color: #999;
      .outRangeOrderBtn {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 199;
      }
    }
    .store_item_bg {
      background-color: #ebedef;
    }
    .col {
      display: inline-block;
      width: 30%;
    }

    .font_blue {
      color: #3fa2ff;
    }
    .font_red {
      color: #f73f3f;
    }
    .font_orange {
      color: #FF9900;
    }
    .outrange {
      position: absolute;
      top: 54px;
      right: 34px;
      padding: 0 6px;
      color: #fff;
      background-color: #f47e5a;
    }
  }
</style>



// WEBPACK FOOTER //
// components/Pages/customer/StoreList.vue